export type { FC } from 'react';

export interface Props {}

export enum ETabs {
    DOWNLOAD,
    CLOSE,
    SPACE
}